import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import RoleInfo from "./RoleInfo";

const EnvironmentChip = ({ name, size = "md" }) => {
  const sizeClasses = size === "sm" ? "px_2 py_0 font_size_xsmall" : "px_2 py_1 font_size_small";

  return (
    <span
      className={`d_inline_block bg_gray border_radius_small font_weight_medium color_primary ${sizeClasses}`}
      style={size === "sm" ? { lineHeight: "1.4" } : {}}
    >
      {name}
    </span>
  );
};

export const EnvironmentFlow = ({ source, target, size = "md" }) => {
  const iconSize = size === "sm" ? "16px" : "20px";

  return (
    <div className="d_flex align_center gap_2">
      <EnvironmentChip name={source} size={size} />
      <MaterialIcon name="arrow_right_alt" style={{ fontSize: iconSize }} className="color_secondary" />
      <EnvironmentChip name={target} size={size} />
    </div>
  );
};

const MetricItem = ({ label, value, color }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
    <span
      style={{
        fontSize: "18px",
        color
      }}
    >
      {value}
    </span>
    <span
      style={{
        fontSize: "12px",
        color: "#6B7280"
      }}
    >
      {label}
    </span>
  </div>
);

const PipelineConfigCard = ({ config, onToggleSettings, metrics }) => {
  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "24px"
        }}
      >
        <div style={{ display: "flex", gap: "32px", alignItems: "center" }}>
          <div style={{ display: "flex", gap: "16px" }}>
            <RoleInfo label="Initiators" type={config.initiator_type} users={config.initiators} />
            <div style={{ width: "1px", background: "#E5E7EB" }} />
            <RoleInfo
              label="Approvers"
              type={config.approver_type}
              users={config.approvers}
              meta={`Minimum Approvers: ${config.min_approvers}`}
            />
          </div>

          {metrics && (
            <div
              style={{
                display: "flex",
                gap: "16px",
                paddingLeft: "24px",
                borderLeft: "1px solid #E5E7EB"
              }}
            >
              <MetricItem label="Total" value={metrics.total} color="black" />
              <MetricItem label="Awaiting" value={metrics.awaited} color="#2563EB" />
              <MetricItem label="Released" value={metrics.released} color="#16A34A" />
            </div>
          )}
        </div>

        <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
          <ButtonActionIcon type="settings" size="md" onClick={onToggleSettings} title="Pipeline Settings" />
        </div>
      </div>
    </div>
  );
};

export default PipelineConfigCard;
